/// <reference path="./index.d.ts" />
import * as favourite from 'api/favourite';
import * as catalog from 'api/catalog';
import * as faq from 'api/faq';
import * as shop from 'api/shop';
import * as user from 'api/user';
import * as entities from 'api/entities';
import * as freeTrial from 'api/free_trials';
import * as payment from 'api/payment';

export { favourite, catalog, faq, user, shop, entities, freeTrial, payment };



// WEBPACK FOOTER //
// ./app/api/index.ts